// extracted by mini-css-extract-plugin
export default {"wrapper":"PricesPage-module--wrapper--E+ogd"};